export enum PaymentType {
  DYNAMIC = 'DYNAMIC',
  FIXED = 'FIXED'
}

export interface FixedPaymentOption  {
  totalAmortizationNumber?: number;
  paymentIntervalId?: number;
}
